// Generated on 2025-11-07T20:51:50.379Z
// This file contains preloaded products top brands data from the API
// Do not edit manually - use 'npm run generate:products-top-brands-data' to regenerate

export const preloadedProductsTopBrands: any = [
  {
    "marca": "DORMAN",
    "cantidadProductosVendidos": "27493"
  },
  {
    "marca": "NAKAMOTO",
    "cantidadProductosVendidos": "17871"
  },
  {
    "marca": "GSP NORTH AMERICA",
    "cantidadProductosVendidos": "16984"
  },
  {
    "marca": "WAGNER QUICKSTOP",
    "cantidadProductosVendidos": "16031"
  },
  {
    "marca": "FEBEST",
    "cantidadProductosVendidos": "13672"
  },
  {
    "marca": "ONNURI",
    "cantidadProductosVendidos": "12995"
  },
  {
    "marca": "BANDO",
    "cantidadProductosVendidos": "12071"
  },
  {
    "marca": "VALVOLINE",
    "cantidadProductosVendidos": "11833"
  },
  {
    "marca": "DENSO",
    "cantidadProductosVendidos": "11280"
  },
  {
    "marca": "DNJ",
    "cantidadProductosVendidos": "10407"
  },
  {
    "marca": "MAHLE ORIGINAL",
    "cantidadProductosVendidos": "9879"
  },
  {
    "marca": "BECK/ARNLEY",
    "cantidadProductosVendidos": "8567"
  },
  {
    "marca": "ECOGARD",
    "cantidadProductosVendidos": "7330"
  },
  {
    "marca": "BLUE PRINT",
    "cantidadProductosVendidos": "6850"
  },
  {
    "marca": "FAG",
    "cantidadProductosVendidos": "6738"
  },
  {
    "marca": "555",
    "cantidadProductosVendidos": "6099"
  },
  {
    "marca": "PT",
    "cantidadProductosVendidos": "5985"
  },
  {
    "marca": "DAYCO",
    "cantidadProductosVendidos": "5741"
  },
  {
    "marca": "MOOG",
    "cantidadProductosVendidos": "5475"
  },
  {
    "marca": "MOTORAD",
    "cantidadProductosVendidos": "5328"
  },
  {
    "marca": "DORMAN PREMIUM",
    "cantidadProductosVendidos": "5324"
  },
  {
    "marca": "MOOG EU",
    "cantidadProductosVendidos": "5305"
  },
  {
    "marca": "PRESTONE",
    "cantidadProductosVendidos": "4966"
  },
  {
    "marca": "HS",
    "cantidadProductosVendidos": "4713"
  },
  {
    "marca": "TENACITY",
    "cantidadProductosVendidos": "4633"
  },
  {
    "marca": "STANDARD/INTERMOTOR",
    "cantidadProductosVendidos": "4591"
  },
  {
    "marca": "WALKER",
    "cantidadProductosVendidos": "4384"
  },
  {
    "marca": "NATIONAL",
    "cantidadProductosVendidos": "4300"
  },
  {
    "marca": "WAGNER",
    "cantidadProductosVendidos": "4161"
  },
  {
    "marca": "EAGLE BHP",
    "cantidadProductosVendidos": "3625"
  }
];

export default preloadedProductsTopBrands;
